var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.6C15.0928 17.6 17.6 15.0928 17.6 12C17.6 8.90721 15.0928 6.4 12 6.4C8.90723 6.4 6.40002 8.90721 6.40002 12C6.40002 15.0928 8.90723 17.6 12 17.6ZM7.20001 12C7.20001 9.34903 9.34905 7.2 12 7.2V16.8C9.34905 16.8 7.20001 14.651 7.20001 12Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0H12.8V4.8H11.2V0Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 19.2H12.8V24H11.2V19.2Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 17.9313L17.9314 16.8L21.3255 20.1941L20.1941 21.3255L16.8 17.9313Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 11.2H24V12.8H19.2V11.2Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.2H4.8V12.8H0V11.2Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 6.59409L20.1941 3.19998L21.3255 4.33135L17.9314 7.72546L16.8 6.59409Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40002 20.1941L5.79414 16.8L6.92551 17.9313L3.53139 21.3255L2.40002 20.1941Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79413 7.72549L2.40002 4.33138L3.53139 3.20001L6.9255 6.59412L5.79413 7.72549Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuning);
export default __webpack_public_path__ + "static/media/Tuning.892c8a4f0731344dc67dfbbcd7b8b21c.svg";
export { ForwardRef as ReactComponent };